import Scroll from "@hg/scroll"

import { CustomModal } from "@/components/Modal"
import { i18n } from "@/i18n"

import styles from "./index.module.scss"

interface Props {
    open: boolean
    onCancel: () => void
}

const RuleModal: React.FC<Props> = (props) => {
    const { open, onCancel } = props

    return (
        <CustomModal
            open={open}
            size="large"
            onCancel={onCancel}
            showCancelBtn={false}
            showOkBtn={false}
        >
            <div className={styles.rules}>
                <Scroll direction="y" className={styles.scroll} rotateDetection>
                    {i18n
                        .getArray("rule.duration", "recall")
                        .map((item, index) => (
                            <div
                                key={index}
                                className={styles.duration}
                                dangerouslySetInnerHTML={{
                                    __html: item,
                                }}
                            />
                        ))}
                    <div className={styles.section}>
                        {i18n.getRecall("rule.title_special_instructions")}
                    </div>
                    {i18n
                        .getArray("rule.special_instructions", "recall")
                        .map((item, index) => (
                            <div className={styles.ruleItem} key={item}>
                                <div className={styles.label}>0{index + 1}</div>
                                <div
                                    className={styles.text}
                                    dangerouslySetInnerHTML={{
                                        __html: item,
                                    }}
                                />
                            </div>
                        ))}
                    <div className={styles.section}>
                        {i18n.getRecall("rule.title_attention")}
                    </div>
                    {i18n
                        .getArray("rule.attention", "recall")
                        .map((item, index) => (
                            <div className={styles.ruleItem} key={item}>
                                <div className={styles.label}>0{index + 1}</div>
                                <div
                                    className={styles.text}
                                    dangerouslySetInnerHTML={{
                                        __html: item,
                                    }}
                                ></div>
                            </div>
                        ))}
                    <div className={styles.section}>
                        {i18n.getRecall("rule.title_remind")}
                    </div>
                    {i18n
                        .getArray("rule.remind", "recall")
                        .map((item, index) => (
                            <div className={styles.ruleItem} key={item}>
                                <div className={styles.label}>0{index + 1}</div>
                                <div
                                    className={styles.text}
                                    dangerouslySetInnerHTML={{
                                        __html: item,
                                    }}
                                ></div>
                            </div>
                        ))}
                </Scroll>
            </div>
        </CustomModal>
    )
}

export default RuleModal
